
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import YouTubeEmbed from './YouTubeEmbed';
import { Youtube } from 'lucide-react';

interface VideoCardProps {
  title: string;
  videoId: string;
  youtubeEmbedUrl?: string;
}

const VideoCard = ({ title, videoId, youtubeEmbedUrl }: VideoCardProps) => {
  // Use the youtubeEmbedUrl if available, otherwise use videoId
  const embedUrl = youtubeEmbedUrl || videoId;
  
  return (
    <Card className="overflow-hidden flex flex-col h-full">
      <CardHeader className="p-4 md:p-6">
        <CardTitle className="text-lg md:text-xl flex items-center gap-2">
          <Youtube className="h-5 w-5 text-red-600" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 md:p-6 pt-0 flex-grow">
        <YouTubeEmbed 
          embedUrl={embedUrl} 
          title={title} 
          className="rounded-md"
        />
      </CardContent>
    </Card>
  );
};

export default VideoCard;
